import { AnswerItem } from 'models/AnswerItem';
import 'assets/scss/card-table-answers.scss';
import React from 'react';

type CardTableAnswersContentProps = {
	answerItems: AnswerItem[];
	extraContent?: any;
};

export const CardTableAnswersContent = ({
	answerItems,
	extraContent,
}: CardTableAnswersContentProps) => {
	return (
		<div className="card-table-answers-container">
			{answerItems.map((answer, index) => (
				<div key={index} className="card-table-answers-item">
					<img src={answer.icon} alt="" />
					<p className="subtitle-2 primary-color" style={{ marginLeft: 8 }}>
						{answer.title}:
					</p>
					<p className="body negro-general">{answer.content}</p>
				</div>
			))}
			{extraContent}
		</div>
	);
};
